module.exports = __webpack_public_path__ + "img/ginzasalon.cb4d3369.jpg";